import React from "react";
import { Link } from "react-router-dom";
import Translator, { __ } from "services/Translator";
import Faqs from "../components/Faqs";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
export default function Contact(props) {
  return (
    <>
      <section className=" container-xxl">
        <div className="contact_page">
          <Tabs
            defaultActiveKey="faq"
            id="uncontrolled-tab-example"
            className="mb-3"
          >
            <Tab eventKey="faq" title="FAQs">
              <Faqs heading={true} {...props} />
            </Tab>
            <Tab eventKey="contact" title="Contact">
              <div className="contact-container">
                <div className="contact-header">
                  <h1>
                    CONTACT <span>GET IN TOUCH</span>
                  </h1>
                </div>
                <div className="contact-content">
                  <div className="contact-info">
                    <h2>DON'T BE SHY</h2>
                    <p>We are happy to answer any question you might have.</p>
                  </div>
                  <form className="contact-form">
                    <input type="text" placeholder="Enter your Name" required />
                    <input
                      type="email"
                      placeholder="Enter a valid email address"
                      required
                    />
                    <textarea
                      placeholder="Enter your message"
                      required
                    ></textarea>
                    <div className="terms-container">
                      <input type="checkbox" id="terms" required />
                      <label htmlFor="terms">
                        I accept the <a href="#">Terms of Service</a>
                      </label>
                    </div>
                    <button className="commonBtn primaryBtn" type="submit">
                      <span className="front">SUBMIT</span>
                    </button>
                  </form>
                </div>
              </div>
            </Tab>
          </Tabs>
        </div>
      </section>
    </>
  );
}
